<template>
  <div class="genomics-bb-down">
    <g-s-tools :initType="'not'" :apiOption="newResQueryDataAll.apiOption" :keyVal="keyVal"
      :checkeds="newResQueryDataAll.checkeds" :searchQueryData="newResQueryDataAll.searchQueryData"
      @updateSearchQueryData="updateSearchQueryData(arguments)">
    </g-s-tools>
    <div class="genomics-bb-down-content">
      <svg :id="keyVal" class="genomice-svg-content" width="100%" style="min-height: 260px"></svg>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import render from "d3-render";
import genomicsD3Utils from "../../common/genomics-d3Utils";
import genomicsACCUtils from "../../common/genomics-AACUtils";
import GSTools from '@/components/molecular/genomicsSearchTools.vue';

export default {
  components: { GSTools, },
  props: {
    codingSite: {
      type: Array,
      default: () => { },
    },
    keyVal: {
      type: String,
      default: () => { },
    },
    newResQueryDataAll: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      size: 'small',
    };
  },
  mounted() {
    this.initBBDataSvg();
    console.log('time4', new Date().getTime())
    console.log('time4', this.newResQueryDataAll)
  },
  methods: {
    updateSearchQueryData(param) {
      this.$emit('updateSearchQueryData', param[0], param[1]);
    },
    // removeBBData(param) {
    //   this.$emit('remove', param[0], param[1]);
    // },
    initBBDataSvg() {
      let lollipopDB = genomicsACCUtils.lollipopData(this.codingSite, this.newResQueryDataAll.bbData);
      // let data = [genomicsD3Utils.lollipopData({ param: lollipopDB, direction: 'down', callback: this.discClickFun })];
      let data = [{
        append: "g",
        class: "g-middle-slider",
        transform: "translate(20, 0)",
        children: [genomicsD3Utils.lollipopSans({ param: lollipopDB, direction: 'down', callback: this.discClickFun })]
      }];
      genomicsD3Utils.transitionContentHeight(this.keyVal, 260);
      return render("#" + this.keyVal + "", data);
    },
    discClickFun(data) {
      data.checkeds = this.newResQueryDataAll.checkeds;
      this.$emit('discClickBBDataFun', data);
    }

  }
}
</script>

<style lang="scss" scoped>
.g-lp-pop-down {
  transform: rotate(180deg);
}

.genomice-search-classes-style {
  float: right;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  margin-left: 5px;
  border-radius: 100%;
  background-color: #979797;
}

// .genomice-search-item-fontsize {
//   // font-size: 12px;
// }
.genomics-bb-tools {
  .hospital-dropdown-link {
    margin-left: 5px;
    margin-right: 10px;
  }

  .hospital-dropdown-link {
    color: #3e7ff7;
    font-size: 12px;
  }

  .m-input-s {
    min-width: 100px;
    margin: 10px 0 5px 0;
  }

  .genomice-search-left {
    float: left;
    font-size: 12px;
    color: #9B9B9B;

  }

  .genomice-search-right {
    float: right;
    font-size: 12px;
    text-align: right;

    /deep/ .ant-input {
      font-size: 12px;
    }
  }
}
</style>